<template>
  <div class="tender-form-item">
    <template v-if="property">
      <template v-if="property.Disabled && property.DisabledMsg">
        <el-tooltip :content="property.DisabledMsg" effect="input" placement="top">
          <component
            :is="componentId"
            v-show="property.visible !== false"
            :ref="property.Key"
            :options="property"
            :param="param"
            :attrs="attrs"></component>
        </el-tooltip>
      </template>
      <template v-else>
        <component
          :is="componentId"
          v-show="property.visible !== false"
          :ref="property.Key"
          :options="property"
          :param="param"
          :attrs="attrs"></component>
      </template>
    </template>
    <template v-else>
      <strong class="red">【{{ propertyKey }}】</strong>
    </template>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import formUtils from "../../js/formUtils";
import FormHouseTradeCenter from './comps/form-house-trade-center.vue'
import FormInputCode from "./comps/form-input-code.vue";
import FormInputTradingCenter from "./comps/form-input-trading-center.vue";
import FormInputAreacode from "./comps/form-input-areacode.vue";
import FormInputAutocomplete from "./comps/form-input-autocomplete.vue";
import FormInputDefault from "./comps/form-input-line.vue";
import FormInputEditor from "./comps/form-input-editor.vue";
import FormInputDatePicker from "./comps/form-input-date-picker.vue";
import FormInputLatestYears from "./comps/form-input-latest-years.vue";
import FormSectionEditor from "./comps/form-section-editor.vue";
import FormSelectDefault from "./comps/form-select-default.vue";
import FormSelectRadio from "./comps/form-select-radio.vue";
import FormSelectCheckbox from "./comps/form-select-checkbox.vue";
import FormSelectCheckboxMargin from "./comps/form-select-checkbox-margin.vue";
import FormSelectGclqd from "./comps/form-select-gclqd.vue";
import FormSelectTime from "./comps/form-select-time.vue";
import FormEvalScore from "./comps/form-eval-score.vue";
import FormEvalScoreJzsj from "./comps/form-eval-score-jzsj.vue";
import FormEvalScoreSzsj from "./comps/form-eval-score-szsj.vue";
import FormEvalScoreEpc from "./comps/form-eval-score-epc.vue";
import FormAddableTable from "./comps/form-addable-table.vue";
import FormAddableTableV2 from "./comps/form-addable-table-v2.vue";
import FormAddableTableV3 from "./comps/form-addable-table-v3.vue";
import FormAddableTableQz from "./comps/form-addable-table-qz.vue";
import FormAddableTableEpc from "./comps/form-addable-table-epc.vue";
import FormAddableTableTraffic from "./comps/form-addable-table-traffic.vue";
import FormInputRegionQz from "./comps/form-input-region-qz.vue";
import FormUploadFile from "./comps/form-upload-file.vue";
import FormUploadFileGclqd from "./comps/form-upload-file-gclqd.vue";
import FormFileTable from "./comps/form-file-table.vue";
import FormSelectBondBanks from "./comps/form-select-bond-banks.vue";

export default {
  name: "TenderFormItem",
  components: {
    FormHouseTradeCenter,
    FormInputCode,
    FormInputAreacode,
    FormInputAutocomplete,
    FormInputDefault,
    FormInputEditor,
    FormInputDatePicker,
    FormInputLatestYears,
    FormSectionEditor,
    FormSelectDefault,
    FormSelectRadio,
    FormSelectCheckbox,
    FormSelectTime,
    FormEvalScore,
    FormAddableTable,
    FormEvalScoreJzsj,
    FormEvalScoreSzsj,
    FormEvalScoreEpc,
    FormAddableTableV2,
    FormAddableTableV3,
    FormAddableTableQz,
    FormAddableTableEpc,
    FormAddableTableTraffic,
    FormUploadFile,
    FormUploadFileGclqd,
    FormFileTable,
    FormInputRegionQz,
    FormSelectCheckboxMargin,
    FormSelectGclqd,
    FormInputTradingCenter,
    FormSelectBondBanks,
  },
  props: {
    chapterIndex: {
      type: Number,
      default: 0,
    },
    sectionIndex: {
      type: Number,
      default: 0,
    },
    propertyKey: {
      type: String,
      default: "",
    },
    attrs: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["formItems"]),
    ...mapGetters(["chapters", "properties"]),
    sectionKey() {
      let { chapterIndex, sectionIndex } = this;
      return `/${chapterIndex}/section-0${sectionIndex + 1}`.replace(/0(\d{2})/, "$1");
    },
    property() {
      let { properties, sectionKey, propertyKey } = this;
      let property = properties[sectionKey][propertyKey];
      if (!property) {
        console.error(`(⓿_⓿)：请在 properties.js 中\n${sectionKey} 章节下设置 ${propertyKey} 字段\n`);
      }
      return property;
    },
    param() {
      let { property } = this;
      if (property) {
        return formUtils.initFormParam(this.property);
      } else {
        return {};
      }
    },
    customComponent () {
      return this.formItems[this.param.componentId]
    },
    componentId() {
      let cId = "form-input-default";
      let ccId = this.attrs.cId;
      if (this.customComponent) return this.customComponent
      switch (this.param.componentId) {
        case "select":
          if (ccId === "radio") {
            cId = "form-select-radio";
          } else {
            cId = "form-select-default";
          }
          break;
        case "time":
          cId = "form-select-time";
          break;
        case "radio":
          cId = "form-select-radio";
          break;
        case "checkbox":
          cId = "form-select-checkbox";
          break;
        case "checkboxMargin":
          cId = "form-select-checkbox-margin";
          break;
        case "selectGclqd":
          cId = "form-select-gclqd";
          break;
        case "latestYears":
          cId = "form-input-latest-years";
          break;
        case "code":
          cId = "form-input-code";
          break;
        case "sectionEditor":
          cId = "form-section-editor";
          break;
        case "editor":
          cId = "form-input-editor";
          break;
        case "areacode":
          cId = "form-input-areacode";
          break;
        case "autocomplete":
          cId = "form-input-autocomplete";
          break;
        case "date":
        case "datetime":
        case "year":
          cId = "form-input-date-picker";
          break;
        case "evalScore":
          cId = "form-eval-score";
          break;
        case "evalScoreJzsj":
          cId = "form-eval-score-jzsj";
          break;
        case "evalScoreSzsj":
          cId = "form-eval-score-szsj";
          break;
        case "evalScoreEpc":
          cId = "form-eval-score-epc";
          break;
        case "addableTable":
          cId = "form-addable-table";
          break;
        case "addableTableV2":
          cId = "form-addable-table-v2";
          break;
        case "addableTableV3":
          cId = "form-addable-table-v3";
          break;
        case "addableTableQz":
          cId = "form-addable-table-qz";
          break;
        case "addableTableEpc":
          cId = "form-addable-table-epc";
          break;
        case "addableTableTraffic":
          cId = "form-addable-table-traffic";
          break;
        case "regionQz":
          cId = "form-input-region-qz";
          break;
        case "uploadFile":
          cId = "form-upload-file";
          break;
        case "uploadFileGclqd":
          cId = "form-upload-file-gclqd";
          break;
        case "fileTable":
          cId = "form-file-table";
          break;
        case "tradingCenter":
          cId = "form-input-trading-center";
          break;
        case "houseTradeCenter":
          cId = "form-house-trade-center";
          break;
        case "bondBanks":
          cId = "form-select-bond-banks";
          break;
        case "custom":
          cId = this.param.componentName;
          break;

        default:
          cId = "form-input-default";
          break;
      }
      return cId;
    },
  },
  created() {},
  methods: {
    getRequiredCount(key) {
      let { param } = this;
      let count = 1;
      switch (param.componentId) {
        case "evalScore":
        case "evalScoreSzsj":
        case "evalScoreEpc":
        case "addableTable":
        case "addableTableV2":
        case "addableTableV3":
        case "addableTableQz":
        case "addableTableEpc":
        case "fileTable":
        case "custom":
          count = this.$refs[key].getRequiredCount();
          break;
      }
      if (this.customComponent) count = this.$refs[key].getRequiredCount()
      return count;
    },
  },
};
</script>
<style lang="scss" scoped>
.tender-form-item {
  display: inline;
  vertical-align: super;
  text-indent: initial;
  .el-form-item {
    display: inline;
    margin: 0 5px;
  }
}
</style>
<style lang="scss">
.el-popper.is-input {
  /* Set padding to ensure the height is 32px */
  padding: 6px 12px;
  background: #c8c9cc;
  .el-popper__arrow::before {
    background: #c8c9cc;
    right: 0;
  }
}
</style>